import '../../style/login/style-app-login.scss'
// import logo_text from '../../assets/imgs/logo_text_only_over_white.svg'
import CtaButton from '../../components/ctaButton/CtaButton'
import { useEffect, useState } from 'react'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { loginConnector } from '../../server/connector/loginConnector'
import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'
import { PASSWORD_NUMBERS_CHARS, PASSWORD_SPECIAL_CHARS } from '../../constants/sharedConstants'

function AppPasswordReset() {
	const [resettingPassword, setResettingPassword] = useState<boolean>(false)
	const [resetFailed, setResetFailed] = useState<boolean>(false)

	const [verifyCode, setVerifyCode] = useState<string>('')
	const [password, setPassword] = useState<string>('')
	const [confirmPassword, setConfirmPassword] = useState<string>('')

	const [passwordHasBeenUpdated, setPasswordHasBeenUpdated] = useState<boolean>(false)
	const [passwordContainsSpecialChars, setPasswordContainsSpecialChars] = useState<boolean>(false)
	const [passwordContainsDigit, setPasswordContainsDigit] = useState<boolean>(false)
	const [passwordLongEnough, setPasswordLongEnough] = useState<boolean>(false)
	const [passwordsMatch, setPasswordsMatch] = useState<boolean>(true)

	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)

	useEffect(() => {
		// check if log in has been checked and confirmed in App.tsx
		if (loginChecked == true) {
			// confirm a user is logged in
			if (userStateData.loggedIn == true) {
				window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)
			} 
		}
	}, [loginChecked])

	const resetPasswordClicked = () => {
		setResettingPassword(true)
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const email: string | null = urlParams.get('email')

		if (email && verifyCode) {
			// loginConnector.performPasswordResetRequest(email, password, resetId).then((successRequest) => {
			loginConnector.performAppPasswordResetRequest(email, password, verifyCode).then((successRequest) => {
				if (!successRequest) {
					setResetFailed(true)
					setResettingPassword(false)
				} else {
					window.location.replace(PAGE_URLS.APP_LOGIN)
				}
			})
		} else {
			setResetFailed(true)
			setResettingPassword(false)
		}
	}

	const passwordChangeHandler = (newValue: string) => {
		let containsSpecialChar: boolean = false
		PASSWORD_SPECIAL_CHARS.split('').forEach((char: string) => {
			if (newValue.includes(char)) {
				containsSpecialChar = true
			}
		})
		setPasswordContainsSpecialChars(containsSpecialChar)
		let containsNumber: boolean = false
		PASSWORD_NUMBERS_CHARS.split('').forEach((char: string) => {
			if (newValue.includes(char)) {
				containsNumber = true
			}
		})
		setPasswordContainsDigit(containsNumber)
		setPasswordLongEnough(newValue.length > 7)
		setPassword(newValue)
		// setPasswordHasBeenUpdated(true)
	}

	const confirmPasswordChangeHandler = (newValue: string) => {
		setConfirmPassword(newValue)
		setPasswordsMatch(newValue === password)
	}
	
	return (
		<>
			<div className='section-wrap'>
				<div className='section-content'>
					<div className='log-in-content'>
						<div className='log-in-content-section'>
							{/* <div className='log-in-logo-wrap'>
								<img
									src={'/imgs/logos/logo-main.svg'}
									className="log-in-logo-img"
									alt="Peyto logo"
									onClick={() => {
										window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
									}}
								/>
							</div> */}
							<div className='log-in-form'>
								<div className='log-in-form-title log-in-form-title-center'>Reset Password</div>
								<div className='log-in-form-caption'>A code has been emailed to you to verify your account</div>
								<input 
									className='log-in-form-input' 
									// type={'email'} 
									placeholder={'Verify Code'} 
									value={verifyCode}
									onChange={(event) => {
										setVerifyCode(event.target.value)
									}}
									disabled={resettingPassword}
								/>
								<input 
									className={`${(passwordContainsSpecialChars === false || passwordContainsDigit === false || passwordLongEnough === false) && password.length > 0 ? 'log-in-form-input log-in-form-input-red' : 'log-in-form-input'}`}
									placeholder={'New Password'} 
									value={password}
									onChange={(event) => {
										passwordChangeHandler(event.target.value)
									}}
									onBlur={() => {
										setPasswordHasBeenUpdated(true)
									}}
									type='password'
									disabled={resettingPassword}
								/>
								{passwordHasBeenUpdated && passwordContainsSpecialChars === false && <div className='log-in-form-requirement-txt'>Must contain special character</div>}
								{passwordHasBeenUpdated && passwordContainsDigit === false && <div className='log-in-form-requirement-txt'>Must contain a digit</div>}
								{passwordHasBeenUpdated && passwordLongEnough === false && <div className='log-in-form-requirement-txt'>Must be at least 8 characters long</div>}
								<input 
									className='log-in-form-input' 
									placeholder={'Confirm Password'} 
									value={confirmPassword}
									onChange={(event) => {
										confirmPasswordChangeHandler(event.target.value)
										// setConfirmPassword(event.target.value)
									}}
									type='password'
									disabled={resettingPassword}
								/>
								{passwordsMatch === false && <div className='log-in-form-requirement-txt'>Passwords must match</div>}
								<CtaButton
									label={resettingPassword ? 'Resetting...' : 'Reset'}
									size='medium'
									onClick={() => resetPasswordClicked()}
									fullWidth={true}
									disabled={
										verifyCode === '' ||
										password === '' ||
										confirmPassword === '' ||
										passwordContainsSpecialChars === false ||
										passwordContainsDigit === false ||
										passwordLongEnough === false ||
										passwordsMatch === false ||
										resettingPassword
									}
								/>
								{resetFailed && <div className='log-in-form-requirement-txt'>Failed to reset password, please contact support</div>}
								<div className='log-in-line-text-span-wrap'>
									<div className='log-in-line-text-span-wrap-span'>or</div>
								</div>
								<div className='log-in-already-have-account'><a href={PAGE_URLS.APP_LOGIN}>Log In</a></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default AppPasswordReset
